import React, {useState, useEffect} from "react";
import {AppSettingsWrap} from "./AppSettings.styles";
import SwitchToggle from "../../Menu/Menu/SwitchToggle";
import Select from "components/molecules/Select";

const AppSettings = () => {
    const [autoPrint, setAutoPrint] = useState(() => {
        const saved = localStorage.getItem("foodie_auto_print_on_accept");
        // Ensure it defaults to true for new users or if not explicitly disabled
        return saved !== "false";
    });

    const [receiptCopies, setReceiptCopies] = useState(() => {
        return localStorage.getItem("foodie_receipt_copies") || "both";
    });

    // Ensure localStorage is initialized correctly on first load if missing
    useEffect(() => {
        if (localStorage.getItem("foodie_auto_print_on_accept") === null) {
            localStorage.setItem("foodie_auto_print_on_accept", "true");
        }
        if (!localStorage.getItem("foodie_receipt_copies")) {
            localStorage.setItem("foodie_receipt_copies", "both");
        }
    }, []);

    const handleAutoPrintToggle = () => {
        const newValue = !autoPrint;
        setAutoPrint(newValue);
        localStorage.setItem("foodie_auto_print_on_accept", newValue);
    };

    const copyOptions = [
        {label: "Both (Restaurant & Customer)", value: "both"},
        {label: "Restaurant Copy Only", value: "restaurant"},
        {label: "Customer Copy Only", value: "customer"},
    ];

    const handleReceiptCopiesChange = e => {
        const val = e.target.value?.value || "both";
        setReceiptCopies(val);
        localStorage.setItem("foodie_receipt_copies", val);
    };

    return (
        <AppSettingsWrap>
            <h2>App Settings</h2>
            <p style={{color: "#777", marginBottom: "30px"}}>
                Configure your application preferences for a better workflow.
            </p>

            <div className="settings-section">
                <strong className="settings-title">Order Management</strong>
                <div className="setting-item">
                    <div className="info">
                        <strong>Auto-print on Accept</strong>
                        <p>Automatically print a receipt when you accept a new order.</p>
                    </div>
                    <SwitchToggle checked={autoPrint} onChange={handleAutoPrintToggle} />
                </div>

                <div className="setting-item" style={{borderBottom: "none"}}>
                    <div className="info" style={{maxWidth: "60%"}}>
                        <strong>Receipt Copies to Print</strong>
                        <p>Choose which copies to print when printing a receipt.</p>
                    </div>
                    <div style={{width: "300px"}}>
                        <Select
                            options={copyOptions}
                            value={copyOptions.find(o => o.value === receiptCopies)}
                            onChange={handleReceiptCopiesChange}
                            isSearchable={false}
                        />
                    </div>
                </div>
            </div>
        </AppSettingsWrap>
    );
};

export default AppSettings;
